import React from 'react';
import Checkbox from 'components/UI/Checkbox';
import Hint from 'components/UI/Hint';

import * as styles from './FormCheckbox.module.scss';

export const FormCheckbox = ({
  field,
  className,
  onChange,
  content,
  domProps,
  inModal,
  prependedTooltip,
}) => {
  return (
    <Checkbox
      className={className}
      onChange={e => onChange(e.target.checked)}
      checked={field.value}
      name={field.name}
      {...domProps}
    >
      <div className={styles.contentWrapper}>
        <span className={styles.content}>{content}</span>
        {prependedTooltip && (
          <Hint
            closeOnBackground
            closeOnScroll
            withIcon
            hintInsideModal={inModal}
            wrapperClassName={styles.hint}
            content={prependedTooltip}
            theme="modalHint"
          />
        )}
      </div>
    </Checkbox>
  );
};
